<script lang="ts" setup>
import AppButton2 from './AppButton2.vue'

const props = defineProps<{
  image: string
  date: string
  title: string
  description: string
  slug: string
}>()
</script>

<template>
  <NuxtLink
    :to="slug"
    class="flex flex-col gap-7.5 group"
  >
    <NuxtImg
      :src="props.image"
      alt="blog image"
      class="object-cover w-full rounded-3xl h-85"
      loading="lazy"
      width="600"
      height="340"
      format="webp"
      quality="100"
    />
    <div class="flex flex-col gap-5">
      <span class="text-H3 text-Tekst">{{ props.title }}</span>
      <span class="text-Menu text-Tekst">{{ props.date }}</span>
      <span class="text-H4 text-Tekst">{{ props.description }}</span>
      <AppButton2>
        <span class="text-Menu">Czytaj więcej</span>
      </AppButton2>
    </div>
  </NuxtLink>
</template>
